export default __webpack_public_path__ + "static/media/voucher_icon.e95902ec.svg";